import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Movies
export const getRecentMovies = (limit = 10) =>
  api.get(`/movies/recent?limit=${limit}`);

export const searchLocalMovies = (query) =>
  api.get(`/movies/search?q=${encodeURIComponent(query)}`);

export const getAllMovies = () =>
  api.get('/movies');

export const searchTMDB = (query) =>
  api.get(`/tmdb/search?q=${encodeURIComponent(query)}`);

export const extractColors = (movie) =>
  api.post('/movies/extract', movie);

// Lights
export const applyTheme = (colors, movieId, targetLightIds = null, movieData = null) =>
  api.post('/lights/apply', { colors, movieId, targetLightIds, movieData });

export const testColor = (color) =>
  api.post('/lights/test', { color });

export const getLights = () =>
  api.get('/hue/lights');

export const getRooms = () =>
  api.get('/hue/rooms');

export const getZones = () =>
  api.get('/hue/zones');

export const getGroups = () =>
  api.get('/hue/groups');

export const discoverBridges = () =>
  api.get('/hue/discover');

export const testBridge = (bridgeIp) =>
  api.post('/hue/test', { bridgeIp });

export const connectBridge = (bridgeIp) =>
  api.post('/hue/connect', { bridgeIp });

// Light State Save/Restore
export const getSavedLightState = () =>
  api.get('/hue/state');

export const saveLightState = (force = false) =>
  api.post('/hue/state/save', { force });

export const restoreLightState = () =>
  api.post('/hue/state/restore');

export const clearSavedLightState = () =>
  api.delete('/hue/state');

// Settings
export const getSettings = () =>
  api.get('/settings');

export const updateSettings = (settings) =>
  api.post('/settings', settings);

// Movie Quotes
export const testMovieQuote = (movie, year = null) => {
  const params = new URLSearchParams({ movie });
  if (year) params.append('year', year);
  return api.get(`/quotes/test?${params.toString()}`);
};

// Hue Remote API OAuth
export const getHueAuthStatus = () =>
  api.get('/hue/auth/status');

export const getHueAuthUrl = () =>
  api.get('/hue/auth/url');

export const disconnectHue = () =>
  api.post('/hue/auth/disconnect');

export default api;


